export const VendorPicker = ({ vendors, value, onChange, invalid }) => {
  const v = vendors.find((x) => x.id === value);
  return (
    <div className="space-y-3">
      <div>
        <label className="label" htmlFor="vendor-select">Vendor *</label>
        <select id="vendor-select" className={`field ${invalid ? "!border-destructive" : ""}`} value={value}
          onChange={(e) => onChange(e.target.value)} data-testid="vendor-select">
          <option value="">Select vendor…</option>
          {vendors.map((x) => (
            <option key={x.id} value={x.id}>{x.name} ({x.code})</option>
          ))}
        </select>
        {!vendors.length && <p className="mt-2 text-sm text-muted-foreground">No vendors yet — add one in Setup.</p>}
      </div>
      {v && (
        <div className="rise grid grid-cols-2 gap-3 rounded-lg bg-muted/60 p-3 text-sm" data-testid="vendor-info-card">
          <Info label="Code" value={v.code} testid="vendor-info-code" />
          <Info label="GSTIN" value={v.gstin || "—"} testid="vendor-info-gstin" />
          <Info label="Location" value={v.location || "—"} testid="vendor-info-location" />
          <Info label="Terms" value={`Payment: ${v.payment_days} days from invoice date`} testid="vendor-info-payment" />
        </div>
      )}
    </div>
  );
};

const Info = ({ label, value, testid }) => (
  <div className="min-w-0">
    <p className="mono-label text-muted-foreground">{label}</p>
    <p className="break-words font-semibold" data-testid={testid}>{value}</p>
  </div>
);
